/**
 * SendIcon/index.js
 * desc: send icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SendIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="send icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.send.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg"><path d="M0.01 18L21 9L0.01 0L0 7L15 9L0 11L0.01 18Z" /></svg>
    </IconButton>
);


export default SendIcon;
